import { render, staticRenderFns } from "./PaqueteEliminarIluminar.vue?vue&type=template&id=374967dc&scoped=true"
import script from "./PaqueteEliminarIluminar.vue?vue&type=script&lang=js"
export * from "./PaqueteEliminarIluminar.vue?vue&type=script&lang=js"
import style0 from "./PaqueteEliminarIluminar.vue?vue&type=style&index=0&id=374967dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374967dc",
  null
  
)

export default component.exports